import Vue from 'vue'
import Vuex from 'vuex';

Vue.use(Vuex);
let store = new Vuex.Store({
  //存储store的各种状态
  state: {
    city: '城市名',
    counter: 3,
    listType: 0
  },
  // 提供用来获取state数据的方法，vuex的计算属性，筛选数据
  getters: {
    getCityFn(state) {
      return state.city
    },
    sqrtCounter(state) {
      return state.counter * state.counter
    },
    getListType(state) {
      return state.listType
    }
  },
  // 提供和后台接口调试的方法，并调用mutations提供的方法，异步操作方法。action提交的是mutation，而不是直接变更状态
  actions: {
    setCityName({commit, state}, name) {
      commit("setCity", name)
    },
    setListType({commit, state}, val) {
      commit("setList", val)
    }
  },
  // 提供存储设置state数据的方法，改变store的状态只能通过mutations方法，同步操作方法
  mutations: {
    setCity(state, name) {
      state.city = name;
    },
    add(state, num) {
      state.counter = state.counter + num
    },
    setList(state, val) {
      state.listType = val
    }
  },
  addNum(state) {
    return function (a) {
      return state.counter + a
    }
  }
})

export default store;



// WEBPACK FOOTER //
// ./src/store/store.js